/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/functions";
/* eslint-enable no-restricted-imports */
import useSWR from "swr";

import { getShippingAtPreviewText } from "./goodsModel";
import { useGenerateHTML } from "./useGenerateHTML";

import type { Goods } from "./goodsModel";
import type { GetGoodsRequest, GetGoodsResponse } from "@spwn/types/functions";
import type { JSONContent } from "@tiptap/core";

/**
 * プレビューグッズを取得する
 */
export const useGetGoodsPreview = ({
  tenantId,
  goodsId,
}: {
  tenantId: string;
  brandId: string;
  shopId: string;
  goodsId: string;
}): {
  goods: Goods;
  error: string | null;
} => {
  const { generateHTML } = useGenerateHTML({
    placeholder:
      "フリーサイズ（XXLサイズ相当：身幅約61cm／身丈約82cm／袖丈約26cm）",
  });
  const { data: goods, error } = useSWR(
    ["getGoods", tenantId, goodsId],
    async () => {
      const { data } = await callGetGoods({
        tenantId,
        goodsId,
      });

      const goods = buildGoods(data, generateHTML, tenantId);

      return goods;
    }
  );

  return {
    // @ts-expect-error TS2322
    goods,
    error,
  };
};

const callGetGoods = async (
  request: GetGoodsRequest
): Promise<{ data: GetGoodsResponse }> => {
  return await firebase.functions().httpsCallable("getGoods")(request);
};

/**
 * レスポンスをグッズモデルへ変換する
 */
const buildGoods = (
  res: GetGoodsResponse,
  generateHTML: (jsonContent: JSONContent) => string,
  tenantId: string
): Goods => {
  const thumbnails =
    res.images.length > 0
      ? res.images.map((image) => {
          return image.url;
        })
      : ["/images/no-img.png"];

  const variants = res.variants.map((variant) => {
    const { id, name, inventory, purchaseLimit, isUnlimitedPurchase } = variant;
    return {
      name,
      purchaseLimit,
      id,
      inventoryQuantity: inventory,
      isUnlimitedPurchase,
    };
  });

  return {
    fulfillmentShipment: {
      title: getShippingAtPreviewText(
        res.deliveryMethod,
        res.deliveryAtEpochMillis
      ),
    },
    thumbnails,
    name: res.name,
    price: res.price,
    id: res.id,
    tags: res.tags,
    // @ts-expect-error TS2322
    variants,
    tenantId,
    isUnlimitedPurchase: res.isUnlimitedPurchase,
    inventoryQuantity: res.inventory,
    purchaseLimit: res.purchaseLimit,
    salesPeriodType: res.salesPeriodType,
    salesStatus: res.salesStatus,
    releasedAt:
      res.releasedAtEpochMillis === null
        ? null
        : new Date(res.releasedAtEpochMillis),
    closedAt:
      res.closedAtEpochMillis === null
        ? null
        : new Date(res.closedAtEpochMillis),
    description: res.description === null ? "" : generateHTML(res.description),
  };
};
